// tabs must have the same value as the tab path
const APPOINTMENTS_WORKFLOWS_TAB = 'appointment-workflows'
const TEST_RESULTS_TAB = 'test-results'

export { APPOINTMENTS_WORKFLOWS_TAB, TEST_RESULTS_TAB }
